import { render, staticRenderFns } from "./app-recorder.vue?vue&type=template&id=49cee252"
import script from "./app-recorder.vue?vue&type=script&lang=js"
export * from "./app-recorder.vue?vue&type=script&lang=js"
import style0 from "./app-recorder.vue?vue&type=style&index=0&id=49cee252&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports